import { z } from 'zod';

export const AuditUserSchema = z.object({
  name: z.string(),
  profilePictureUrl: z.string().nullable(),
});

export const AuditEntrySchema = z.object({
  id: z.number(),
  action: z.string(),
  userId: z.string().nullable(),
  role: z.string().nullable(),
  entityType: z.string().nullable(),
  entityId: z.string().nullable(),
  inputs: z.unknown(),
  createdAt: z.string(),
  user: AuditUserSchema.nullable(),
});

export type AuditEntry = z.infer<typeof AuditEntrySchema>;

export const ListAuditsResponseSchema = z.object({
  entries: z.array(AuditEntrySchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});

export type ListAuditsResponse = z.infer<typeof ListAuditsResponseSchema>;
